export const  SECCIONES = [
'Home', 'Documentacion', 'Contactos'
]

export const LINKWHATSAPP = 'https://api.whatsapp.com/send?phone=573155404983'